module.exports = __webpack_public_path__ + "static/media/take.52e2abaf.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/story/bgm/take.mp3
// module id = 82
// module chunks = 0